"use strict";
/** @module BryxApi.SupportApi */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ts_mixer_1 = require("ts-mixer");
var BryxApi_1 = require("../BryxApi");
var spoonClient_1 = require("../../spoonClient");
var TestHttpClient_1 = require("../TestHttpClient");
var AgencyMixin_1 = require("./AgencyMixin");
var AgentMixin_1 = require("./AgentMixin");
var ClientMixin_1 = require("./ClientMixin");
var DeviceMixin_1 = require("./DeviceMixin");
var GeocodeMixin_1 = require("./GeocodeMixin");
var HospitalMixin_1 = require("./HospitalMixin");
var ImageMixin_1 = require("./ImageMixin");
var ImpersonateMixin_1 = require("./ImpersonateMixin");
var JobMixin_1 = require("./JobMixin");
var MergeMixin_1 = require("./MergeMixin");
var NoteMixin_1 = require("./NoteMixin");
var ResetPasswordMixin_1 = require("./ResetPasswordMixin");
var SCUMixin_1 = require("./SCUMixin");
var SignupMixin_1 = require("./SignupMixin");
var SiteSurveyMixin_1 = require("./SiteSurveyMixin");
var StatsMixin_1 = require("./StatsMixin");
var StreamMixin_1 = require("./StreamMixin");
var TestingToolkitMixin_1 = require("./TestingToolkitMixin");
var AlertingLocationsMixin_1 = require("./AlertingLocationsMixin");
/**
 * Mixin class for support API calls.
 */
var SupportMixinA = /** @class */ (function (_super) {
    __extends(SupportMixinA, _super);
    function SupportMixinA() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SupportMixinA;
}(ts_mixer_1.Mixin(AgencyMixin_1.default, AgentMixin_1.default, ClientMixin_1.default, DeviceMixin_1.default, GeocodeMixin_1.default, HospitalMixin_1.default, ImageMixin_1.default, ImpersonateMixin_1.default, JobMixin_1.default, MergeMixin_1.default)));
/**
 * Mixin class for support API calls.
 */
var SupportMixinB = /** @class */ (function (_super) {
    __extends(SupportMixinB, _super);
    function SupportMixinB() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SupportMixinB;
}(ts_mixer_1.Mixin(NoteMixin_1.default, ResetPasswordMixin_1.default, SCUMixin_1.default, SignupMixin_1.default, SiteSurveyMixin_1.default, StatsMixin_1.default, StreamMixin_1.default, TestingToolkitMixin_1.default, AlertingLocationsMixin_1.default)));
/**
 * Class for management API calls.
 */
var SupportApi = /** @class */ (function (_super) {
    __extends(SupportApi, _super);
    function SupportApi(config, local, testResponses) {
        if (config === void 0) { config = { serverType: 'dev', site: 'test', version: '0' }; }
        var _this = _super.call(this, config, local, testResponses) || this;
        _this.nonSupportApiRoot = _this.baseUrl + "/api/2.2/";
        _this.defaultApiRoot = _this.baseUrl + "/api/2.2/support";
        _this.apiRoot = local.overrideAPIRoot || _this.defaultApiRoot;
        _this.http = (function () {
            var httpClientConfig = {
                baseUrl: _this.apiRoot,
                transformRequest: function (request) {
                    var headers = request.headers || {};
                    // const currentApiKey = getCurrApiKey(); // BryxLocal.getApiKey();
                    var currentApiKey = local ? local.apiKey : null;
                    if (currentApiKey != null) {
                        headers['X-API-KEY'] = currentApiKey;
                    }
                    if (request.body != null) {
                        headers['content-type'] = 'application/json';
                    }
                    request.headers = headers;
                    return request;
                },
            };
            if (testResponses) {
                if (local) {
                    return new TestHttpClient_1.default(httpClientConfig, testResponses, _this.local);
                }
                else {
                    return new TestHttpClient_1.default(httpClientConfig, testResponses);
                }
            }
            return new spoonClient_1.HttpClient(httpClientConfig);
        })();
        _this.httpNonSupport = (function () {
            var httpClientConfig = {
                baseUrl: _this.nonSupportApiRoot,
                transformRequest: function (request) {
                    var headers = request.headers || {};
                    // const currentApiKey = getCurrApiKey(); // BryxLocal.getApiKey();
                    var currentApiKey = local ? local.apiKey : null;
                    if (currentApiKey != null) {
                        headers['X-API-KEY'] = currentApiKey;
                    }
                    if (request.body != null) {
                        headers['content-type'] = 'application/json';
                    }
                    request.headers = headers;
                    return request;
                },
            };
            if (testResponses) {
                if (local) {
                    return new TestHttpClient_1.default(httpClientConfig, testResponses, _this.local);
                }
                else {
                    return new TestHttpClient_1.default(httpClientConfig, testResponses);
                }
            }
            return new spoonClient_1.HttpClient(httpClientConfig);
        })();
        return _this;
    }
    return SupportApi;
}(ts_mixer_1.Mixin(BryxApi_1.default, SupportMixinA, SupportMixinB)));
exports.default = SupportApi;
//# sourceMappingURL=index.js.map